export default __webpack_public_path__ + "static/media/reports-3.06a86b9c.png";